import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var reset_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M7 11.5h10V13H7z" }) });
export {
  reset_default as default
};
//# sourceMappingURL=reset.js.map
